import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import Swiper from 'swiper';

@Component({
  selector: 'terra-image-slider',
  templateUrl: './image-slider.component.html',
  styleUrls: ['./image-slider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class ImageSliderComponent {
  @ViewChild('swiper') swiperRef: ElementRef | undefined;

  @Input() navigation = true;
  @Input() pagination = true;
  @Input() lazyLoad = true;
  @Input() imageUrls: string[];
  
  @Output() onIndexChanged = new EventEmitter<number>();


  public activeindexchange(event: CustomEvent<[swiper: Swiper]>) {
    const index = event?.detail[0]?.activeIndex;
    if (index) {
      this.onIndexChanged.emit(index);
    }
  }

  public goToSlide(i: number) {
    const swiper: Swiper = this.swiperRef?.nativeElement?.swiper;
    swiper?.slideTo(i);
  }
}
